/**
 * Reusable component for editing ResourceLinks
 *
 * NOTE: The Yote _resource assigned to a given ResourceLink is immutable and
 * passed in as a prop to this component.
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// import third-party libraries
import _ from 'lodash';

// import actions
import * as resourceLinkActions from '../resourceLinkActions';

// import global components
import Base from '../../../global/components/BaseComponent.js.jsx';

import ResourceLinkModal from './ResourceLinkModal.js.jsx';


class AdminResourceLinkListItem extends Base {
  constructor(props) {
    super(props);
    this.state = {
      isEditing: false
    }
    this._bind(
      '_closeModal'
      , '_handleDelete'
    )
  }

  _closeModal() {
    this.setState({isEditing: false});
  }

  _handleDelete() {
    const { dispatch, refId, refKey, resourceLink } = this.props;
    dispatch(resourceLinkActions.sendDelete(resourceLink._id));
    dispatch(resourceLinkActions.invalidateList(refKey, refId));
  }

  render() {
    const { refId, refKey, resourceLink } = this.props;
    const { isEditing, newResourceLink } = this.state;
    const isEmpty = (
      !resourceLink
      || !resourceLink._id
    )
    if(!isEmpty) {

      return (
        <div className="resource-link-item -admin">
          <div className="-display-name tooltip">
            <div className="-tip-text -bottom">
              <p><a href={resourceLink.url} target="_blank">{resourceLink.url}</a></p>
            </div>
            <div>{resourceLink.name}</div>
          </div>
          <div className="-buttons">
            <button className="yt-btn x-small info link" onClick={() => this.setState({isEditing: true})}>Edit</button>
            <button className="yt-btn x-small link danger" onClick={this._handleDelete}>Delete</button>
          </div>
          <ResourceLinkModal
            closeModal={this._closeModal}
            dispatch={this.props.dispatch}
            formType="Update"
            isOpen={isEditing}
            refId={refId}
            refKey={refKey}
            resourceLink={resourceLink}
          />
        </div>
      )
    } else {
      return null
    }
  }
}

AdminResourceLinkListItem.propTypes = {
  dispatch: PropTypes.func.isRequired
  , refId: PropTypes.string.isRequired
  , refKey: PropTypes.oneOf([
    '_course'
    , '_group'
    , '_contentModule'
  ]).isRequired
  , resourceLink: PropTypes.object.isRequired
}

export default AdminResourceLinkListItem;



// WEBPACK FOOTER //
// modules/resourceLink/components/AdminResourceLinkListItem.js.jsx